// extracted by mini-css-extract-plugin
export default {"primary":"#f94848","secondary":"#a3e261","light":"#ededed","info":"#e23d3d","dark":"#343a40"};